import { BASE_API_URL } from 'src/utils/app-constants'
import { MINI_API_URL } from 'src/utils/app-constants'

export const AGENT_URL = `${BASE_API_URL}organisation`
export const CUSTOMER_URL = `${BASE_API_URL}customer`
export const MAPPING_ANALYTICS_URL = `${BASE_API_URL}organisation/mapping-analytics`
export const RIDER_URL = `${BASE_API_URL}organisation?organisation_type=rider`
export const SUPPLIER_URL = `${BASE_API_URL}organisation?organisation_type=supplier`
export const USER_URL = `${BASE_API_URL}user`
export const LOGIN_URL = `${BASE_API_URL}auth/login`
export const PRODUCT_URL = `${BASE_API_URL}product`
export const INVENTORY_PRODUCTS_URL = `${BASE_API_URL}inventory-products`
export const BULK_STOCK_RESET = `${BASE_API_URL}bulk-stock-reset`
export const INVENTORY_STATUS_URL = `${BASE_API_URL}inventory-status`
export const PRODUCT_BY_ID = (id) => `/product/${id}`

export const PRODUCT_URL_META = `${BASE_API_URL}product-meta`
export const PRODUCT_INVENTORY_JOURNAL_URL = `${BASE_API_URL}products`
export const PRODUCTS_URL = `${BASE_API_URL}products`
export const PRODUCT_URL_TYPE = `${BASE_API_URL}producttype`
export const PRICE_LIST_URL = `${BASE_API_URL}price-list`
export const ROLES_URL = `${BASE_API_URL}role`
export const UNITS_URL = `${BASE_API_URL}unit`
export const ORGANISATION_CATEGORY_URL = `${BASE_API_URL}organisationcategory`
export const ORGANISATION_CATEGORY_TYPE_URL = `${BASE_API_URL}organisationcategorytype`
export const VEHICLE_OWNERS_URL = `${BASE_API_URL}owners`
export const TRUCK_URL = `${BASE_API_URL}truck`
export const TRUCK_URL_V2 = `${BASE_API_URL}truck-v2`
export const COOLBOX_URL = `${BASE_API_URL}coolbox`
export const MAINTENANCE_URL = `${BASE_API_URL}maintenancetype`
export const APPUSER_URL = `${BASE_API_URL}appuser`
export const ORDER_URL = `${BASE_API_URL}order`
export const ORDERS_URL = `${BASE_API_URL}orders`
export const ORDER_AUTO_CANCEL_URL = `${BASE_API_URL}order-auto-cancel`
export const ORDER_AUTO_CANCEL_LOG_URL = `${BASE_API_URL}order-auto-cancel-log`
export const ORDER_RETURN_REASON = `${BASE_API_URL}order-return-reason`
export const ORDER_RETURN_NUMBER_URL = `${BASE_API_URL}orderreturnnumber`
export const DOCUMENT_URL = `${BASE_API_URL}organisationdocument`
export const DOCUMENT_TYPE_URL = `${BASE_API_URL}documenttype`
export const FEEDBACK_URL = `${BASE_API_URL}feedback`
export const LOCATION_URL = `${BASE_API_URL}organisationlocation`
export const PAYMENT_URL = `${BASE_API_URL}payment`
export const STATS_URL = `${BASE_API_URL}stats`
export const DISPATCH_URL = `${BASE_API_URL}dispatch`
export const LOAD_REQUEST_URL = `${BASE_API_URL}stock-transfer`
export const WAREHOUSES_URL = `${BASE_API_URL}warehouse`
export const WAREHOUSES_PRODUCT_URL = `${BASE_API_URL}warehouse-product`
export const INVOICE_URL = `${BASE_API_URL}invoice`
export const INVOICE_PAYMENT_URL = `${BASE_API_URL}invoice-payment`
export const RETURNS_URL = `${BASE_API_URL}order-return`
export const ORDER_RETURN_APPROVAL_URL = `${BASE_API_URL}order-return-approval`
export const DISPATCH_RETURN_APPROVAL_URL = `${BASE_API_URL}dispatch-return-approval`
export const DISPATCH_RETURN_LOG_URL = `${BASE_API_URL}dispatch-return-log`
export const COUNTRIES_URL = `${BASE_API_URL}country`
export const REGIONS_URL = `${BASE_API_URL}region`
export const AREAS_URL = `${BASE_API_URL}area`
export const ZONES_URL = `${BASE_API_URL}zone`
export const ROUTES_URL = `${BASE_API_URL}route`
export const ROUTES_SCHEDULE_URL = `${BASE_API_URL}route-schedule`
export const PAYMENT_OVERRIDE_URL = `${BASE_API_URL}payment-override`
export const PAYMENT_REFUND_URL = `${BASE_API_URL}payment-refunds`
export const PAYMENT_OVERRIDE_STATS_URL = `${BASE_API_URL}payment-override/dashboard/stats`
export const PAYMENT_OVERRIDE_TREND_URL = `${BASE_API_URL}payment-override/dashboard/trend`
export const PAYMENT_OVERRIDE_HISTORY_URL = `${BASE_API_URL}payment-override/dashboard/history`
export const RECONCILIATION_URL = `${BASE_API_URL}reconciliation`
export const EXPECTED_BANK_RECONCILIATION_URL = `${BASE_API_URL}bank-reconciliation/expected`
export const SUPPLIER_PAYMENT_URL = `${BASE_API_URL}supplier-payments`
export const CREDIT_NOTES_URL = `${BASE_API_URL}credit-note`
export const CREDIT_NOTE_COUNTS_URL = `${BASE_API_URL}credit-note-counts`
export const CREDIT_NOTE_ITEM_URL = `${BASE_API_URL}credit-note-item`

export const RECEIPT_URL = `${BASE_API_URL}payment-receipt`
export const DISPATCH_ITEM_URL = `${BASE_API_URL}dispatch-item`
export const DISPATCH_ITEM_V2_URL = `${BASE_API_URL}dispatch-item-v2`
export const DISPATCH_NUMBER_URL = `${BASE_API_URL}dispatchnumber`
export const DISPATCH_RETURN_URL = `${BASE_API_URL}dispatch-return`
export const DISPATCH_RETURN_ITEM_URL = `${BASE_API_URL}dispatch-return-item`
export const FAQ_URL = `${BASE_API_URL}faq`
export const UOM_GROUP_URL = `${BASE_API_URL}unitgroup`
export const NOTIFICATIONS_URL = `${BASE_API_URL}notification`
export const BANK_URL = `${BASE_API_URL}bank`
export const BANK_BRANCH_URL = `${BASE_API_URL}bank-branch`
export const ORG_BANK_URL = `${BASE_API_URL}organisationbank`
export const PRODUCTS_OFFERED_URL = `${BASE_API_URL}organisationproduct`
export const STOCK_APPROVAL_URL = `${BASE_API_URL}stock-approval`
export const BULK_STOCK_APPROVAL_URL = `${BASE_API_URL}bulk-stock-approval`
export const BULK_STOCK_ADJUSTMENT_URL = `${BASE_API_URL}bulk-stock-adjustment`
export const DISPATCH_ORDER_URL = `${BASE_API_URL}dispatch-order`
export const ORGANISATION_PRIORITY = `${BASE_API_URL}organisation-priority`
export const MODULES_URL = `${BASE_API_URL}module`
export const MODULE_ACTION_URL = `${BASE_API_URL}module-action`
export const USER_MODULE_ACTION_URL = `${BASE_API_URL}user-module`
export const PRODUCT_VOLUME_URL = `${BASE_API_URL}product-vol-weight`
export const PRODUCT_IMAGE_URL = `${BASE_API_URL}productimage`
export const PRODUCT_DISCOUNT_URL = `${BASE_API_URL}productdiscount`
export const ADJUST_PRICE_URL = `${BASE_API_URL}product-price-approval`
export const DISPATCH_SUMMARY_REPORT = `${BASE_API_URL}dispatch-item-report`
export const DISPATCH_SUMMARY_ITEMS_REPORT = `${BASE_API_URL}dispatch-item-summary`
export const DISPATCH_RETURN_REPORT = `${BASE_API_URL}dispatch-return-item`
export const DISPATCH_RETURN_SUMMARY = `${BASE_API_URL}dispatch-return-item-summary`
export const SUPPLIER_REPORT_URL = `${BASE_API_URL}stock-receive-summary`
export const WAREHOUSE_PRODUCTS_URL = `${BASE_API_URL}warehouse-product`
export const WAREHOUSE_PRODUCT_LOGS_URL = `${BASE_API_URL}warehouse-product-log`
export const NEW_OUTLETS_URL = `${MINI_API_URL}outlets`
export const DISPATCH_ORDER_ITEM_URL = `${BASE_API_URL}dispatch-order-item`
export const DISPATCH_APPROVAL_URL = `${BASE_API_URL}dispatch`
export const PAYMENT_PROCESSING_URL = `${BASE_API_URL}payment-processing`
export const DISPATCH_PAYMENT_DETAIL = `${BASE_API_URL}dispatch-payment-detail`
export const VEHICLE_PENALTY_URL = `${BASE_API_URL}vehicle-penalty`
export const PAYMENT_METHODS_URL = `${BASE_API_URL}payment-methods`
export const PAYMENT_STATUS_URL = `${BASE_API_URL}payment-status`
export const PAYMENT_RETRY_URL = `${BASE_API_URL}payment-retry`
export const PAYMENT_PROCESS_URL = `${BASE_API_URL}payment-process`
export const CASH_PAYMENT_URL = `${BASE_API_URL}cash-payment`
export const CASH_PAYMENT_AUDIT_URL = `${BASE_API_URL}cash-payment-audit`
export const CASH_COUNT_VERIFICATION_URL = `${BASE_API_URL}cash-count-verification`
export const CASHIER_CASH_COUNT_URL = `${BASE_API_URL}cashier-cash-count`
export const MANAGER_CASH_VERIFICATION_URL = `${BASE_API_URL}manager-cash-verification`
export const FINANCE_CASH_VERIFICATION_URL = `${BASE_API_URL}finance-cash-verification`
export const CASH_SHORT_SOURCE_URL = `${BASE_API_URL}cash-short-source`
export const CASH_SHORT_URL = `${BASE_API_URL}cash-short`
export const CASH_SHORT_SUMMARY_URL = `${BASE_API_URL}cash-short/summary`
export const CASH_SHORT_DETAIL_URL = (id) => `${BASE_API_URL}cash-short/${id}`
export const CASH_SHORT_RECOVERY_URL = (id) => `${BASE_API_URL}cash-short/${id}/recovery`
export const CASH_SHORT_RECOVERY_VERIFY_URL = (shortId, recoveryId) => `${BASE_API_URL}cash-short/${shortId}/recovery/${recoveryId}/verify`
export const CASH_SHORT_SOURCE_DETAIL_URL = (id) => `${BASE_API_URL}cash-short-source/${id}`
export const SAFE_LEDGER_URL = `${BASE_API_URL}safe-ledger`
export const SAFE_LEDGER_SUMMARY_URL = `${BASE_API_URL}safe-ledger/summary`
export const SAFE_LEDGER_ALLOCATION_HEALTH_URL = `${BASE_API_URL}safe-ledger/allocation-health`
export const SAFES_URL = `${BASE_API_URL}safes`
export const SAFE_MOVEMENTS_URL = `${BASE_API_URL}safe-movements`
export const MASTER_SAFE_WITHDRAWALS_URL = `${BASE_API_URL}master-safe-withdrawals`
export const DAILY_SAFE_OUTBOUND_TRANSACTIONS_URL = `${BASE_API_URL}daily-safe-outbound-transactions`
export const MASTER_SAFE_OUTBOUND_TRANSACTIONS_URL = `${BASE_API_URL}master-safe-outbound-transactions`
export const CASHIER_SAFE_DAILY_URL = `${BASE_API_URL}cashier-safe/daily`
export const CASHIER_SAFE_MASTER_URL = `${BASE_API_URL}cashier-safe/master`


export const CASHIER_TILLS_URL = `${BASE_API_URL}cashier-till`
export const CASHIER_TILL_DETAIL_URL = (tillId) => `${BASE_API_URL}cashier-till/${tillId}`
export const CASHIER_TILL_DEACTIVATE_URL = (tillId) => `${BASE_API_URL}cashier-till/${tillId}/deactivate`
export const WORKING_FLOAT_SESSIONS_URL = `${BASE_API_URL}working-float-session`
export const WORKING_FLOAT_SUMMARY_URL = `${BASE_API_URL}working-float-session/summary`
export const WORKING_FLOAT_SESSION_DETAIL_URL = (sessionId) => `${BASE_API_URL}working-float-session/${sessionId}`
export const WORKING_FLOAT_SESSION_RECEIVE_URL = (sessionId) => `${BASE_API_URL}working-float-session/${sessionId}/receive`
export const WORKING_FLOAT_SESSION_ACTIVATE_URL = (sessionId) => `${BASE_API_URL}working-float-session/${sessionId}/activate`
export const WORKING_FLOAT_SESSION_CASHIER_SUBMIT_URL = (sessionId) => `${BASE_API_URL}working-float-session/${sessionId}/cashier-submit`
export const WORKING_FLOAT_SESSION_MANAGER_VERIFY_URL = (sessionId) => `${BASE_API_URL}working-float-session/${sessionId}/manager-verify`
export const WORKING_FLOAT_SESSION_CLOSE_URL = (sessionId) => `${BASE_API_URL}working-float-session/${sessionId}/close`
export const WORKING_FLOAT_SESSION_CANCEL_URL = (sessionId) => `${BASE_API_URL}working-float-session/${sessionId}/cancel`
export const SAFE_MOVEMENT_APPROVE_URL = (movementId) =>
  `${BASE_API_URL}safe-movements/${movementId}/approve`
export const SAFE_REASONS_URL = `${BASE_API_URL}safe-reasons`
export const SAFE_MOVEMENT_ALLOCATIONS_URL = (movementId) =>
  `${BASE_API_URL}safe-movements/${movementId}/allocations`
export const END_OF_DAY_CLOSING_URL = `${BASE_API_URL}end-of-day-closing`
export const PAYMENT_VERIFICATION_URL = `${BASE_API_URL}payment-verification`
export const PAYMENT_VERIFICATION_AUDIT_URL = `${BASE_API_URL}payment-verification-audit`
export const SYSTEM_SETTINGS_URL = `${BASE_API_URL}system-settings`
export const PAYMENT_TRIP_ENTRY = `${BASE_API_URL}payment/create-trip-entries`
export const PAYMENT_SUMMARY = `${BASE_API_URL}dispatch/payment-summary`
export const VEHICLE_PAYMENT_SUMMARY = `${BASE_API_URL}vehicle-payment-summary`
export const BANKED_ENTRIES = `${BASE_API_URL}banking/banked-vs-paid`
export const VALIDATE_REALTIME = `${BASE_API_URL}payment/validate-realtime`
export const LOCATION_TOKEN_URL = `${BASE_API_URL}location-token`
export const LOCATION_TOKEN_STATS_URL = `${BASE_API_URL}location-token-stats`
export const LOCATION_TOKEN_BY_TOKEN_URL = `${BASE_API_URL}location-token/by-token/`
export const BULK_LOCATION_TOKEN_URL = `${BASE_API_URL}bulk-location-tokens`
export const TILL_URL = `${BASE_API_URL}till`
export const TILL_ASSIGN_URL = `${BASE_API_URL}truck-till/assignment`
export const TILL_STATUS_URL = `${BASE_API_URL}till`
export const TILL_SWAP_URL = `${BASE_API_URL}truck-till/assignment`
export const BASE_RATE_URL = `${BASE_API_URL}base-rate`
export const STK_INITIATE_URL = `${BASE_API_URL}ncba-stk/initiate`
export const STK_QUERY_URL = `${BASE_API_URL}ncba-stk/query`
export const STK_LOGS_URL = `${BASE_API_URL}ncba-stk/logs`
export const STK_ANALYTICS_URL = `${BASE_API_URL}ncba-stk/analytics`

export const MOVE_WAREHOUSE_PRODUCT_URL = `${BASE_API_URL}move-warehouse-product`
export const LOCAL_PURCHASE_ORDER_URL = `${BASE_API_URL}local-purchase-order`
export const LOCAL_PURCHASE_ORDER_COUNTS_URL = `${BASE_API_URL}local-purchase-order-counts`
export const LOCAL_PURCHASE_ORDER_ITEM_URL = `${BASE_API_URL}local-purchase-order-item`

// Store Dispatch URLs
export const STORE_DISPATCH_URL = `${BASE_API_URL}store-dispatch`
export const STORE_RELEASE_URL = `${BASE_API_URL}store-release`
export const STORE_DISPATCH_REPORTS_URL = `${BASE_API_URL}store-dispatch/reports`

// Bank Statement Upload URLs
export const BANK_STATEMENT_UPLOADS = `${BASE_API_URL}bank-statement-uploads`
export const BANK_STATEMENT_UPLOAD = (id) => `${BASE_API_URL}bank-statement-uploads/${id}`
export const BANK_STATEMENT_PROCESS = (id) => `${BASE_API_URL}bank-statement-uploads/${id}/process`
export const BANK_STATEMENT_STATUS = (id) => `${BASE_API_URL}bank-statement-uploads/${id}/status`
export const BANK_STATEMENT_STATS = `${BASE_API_URL}bank-statement-uploads/stats`
export const BANK_STATEMENT_DOWNLOAD = (id) =>
  `${BASE_API_URL}bank-statement-uploads/${id}/download`

// Bank Transaction Claiming URLs
export const BANK_TRANSACTION_CLAIM = (id) => `${BASE_API_URL}bank-transactions/${id}/claim`
export const BANK_TRANSACTION_UNCLAIM = (id) => `${BASE_API_URL}bank-transactions/${id}/unclaim`
export const BANK_TRANSACTION_BATCH_CLAIM = `${BASE_API_URL}bank-transactions/batch-claim`
export const BANK_TRANSACTION_CLAIMING_STATUS = (id) =>
  `${BASE_API_URL}bank-transactions/${id}/claim-status`
export const BANK_TRANSACTION_CLAIMING_HISTORY = (id) =>
  `${BASE_API_URL}bank-transactions/${id}/claim-history`
export const BANK_TRANSACTION_CLAIMING_SEARCH = (uploadId) =>
  `${BASE_API_URL}bank-statement-uploads/${uploadId}/transactions/search`

// Bank Transaction Conversion URLs
export const BANK_TRANSACTION_BATCH_CONVERSION = `${BASE_API_URL}bank-transactions/batch-convert`
export const BANK_STATEMENT_RECENT = `${BASE_API_URL}bank-statement-uploads/recent`

// Categories
// CategoryResource endpoints
export const CATEGORY_URL = `${BASE_API_URL}category`
export const CATEGORY_BY_ID = (id) => `${BASE_API_URL}category/${id}`

// CategoryHierarchyResource endpoints
export const CATEGORY_HIERARCHY_URL = `${BASE_API_URL}category/hierarchy`

// CategoryWeightRangeResource endpoints
export const CATEGORY_WEIGHT_RANGE_URL = `${BASE_API_URL}category/weight-range`
export const CATEGORY_WEIGHT_RANGE_BY_ID = (id) => `${BASE_API_URL}category/weight-range/${id}`

// CategoryUtilitiesResource endpoints
export const CATEGORY_UTILITIES_URL = `${BASE_API_URL}category/utilities`

// Product categorization endpoints
export const PRODUCT_CATEGORIZATION_URL = `${BASE_API_URL}product/categorization`
export const PRODUCT_CATEGORIZATION_UTILITIES_URL = `${BASE_API_URL}product/categorization/utilities`

// Packaging endpoints
export const PACKAGING_URL = `${BASE_API_URL}packaging`
export const PACKAGING_TEMPLATES_URL = `${BASE_API_URL}packaging-templates`
export const PACKAGING_LEVELS_URL = `${BASE_API_URL}packaging-levels`
export const PACKAGING_UTILS_URL = `${BASE_API_URL}packaging-utils`

// Product packaging endpoints
export const PRODUCT_PACKAGING_URL = `${BASE_API_URL}product/packaging`

export const PRODUCT_FORMS_URL = `${BASE_API_URL}product-forms`

export const ROUTE_ASSIGNMENTS_URL = `${BASE_API_URL}daily-route-assignments`
export const ROUTE_ASSIGNMENT_LOGS_URL = `${BASE_API_URL}daily-route-assignment-logs`
export const AGENT_ROUTE_SUMMARY_URL = `${BASE_API_URL}agent-route-summary`
export const BULK_ROUTE_ASSIGNMENTS_URL = `${BASE_API_URL}bulk-route-assignments`

export const SALES_AGENT_PERFORMANCE_URL = `${BASE_API_URL}sales-agent-performance`

// Organisation Pricing endpoints
export const ORGANISATION_PRICING_URL = `${BASE_API_URL}organisation-pricings`
export const ORGANISATION_PRICING_BY_ID = (id) => `${BASE_API_URL}organisation/${id}/pricing`
export const SELF_COLLECTION_PRICING_REQUESTS_URL = `${BASE_API_URL}organisation/pricing/self-collection/requests`
export const SELF_COLLECTION_PRICING_REQUEST_POST_URL = (id) =>
  `${BASE_API_URL}organisation/${id}/pricing/self-collection/request`
export const SELF_COLLECTION_PRICING_APPROVAL_URL = (id) =>
  `${BASE_API_URL}organisation/pricing/self-collection/approval/${id}`

// Call Actions and Call Status endpoints
export const CALL_ACTIONS_URL = `${BASE_API_URL}call-actions`
export const CALL_ACTION_BY_ID = (id) => `${BASE_API_URL}call-actions/${id}`
export const CALL_STATUS_URL = `${BASE_API_URL}call-status`
export const CUSTOMER_CALL_ACTIONS_URL = `${BASE_API_URL}customer-call-actions`
export const CUSTOMER_CALL_ACTION_BY_ID = (id) => `${BASE_API_URL}customer-call-actions/${id}`
export const ORGANISATION_CALL_STATUS_URL = (id) => `${BASE_API_URL}organisation/${id}/call-status`
export const ORGANISATION_FREQUENTLY_PURCHASED_URL = (id) =>
  `${BASE_API_URL}organisation/${id}/frequently-purchased-products`

export const ROUTE_V2_URL = `${BASE_API_URL}route-v2`
export const SUB_ROUTE_URL = `${BASE_API_URL}sub-route`

export const SUPPLIER_INVOICE_URL = `${BASE_API_URL}supplier-invoice`
export const SUPPLIER_INVOICE_SUMMARY_URL = `${BASE_API_URL}supplier-invoice-summary`
export const SUPPLIER_INVOICE_PAYMENT_URL = `${BASE_API_URL}supplier-invoice-payment`
export const BULK_SUPPLIER_INVOICE_PAYMENT_URL = `${BASE_API_URL}bulk-supplier-invoice-payment`
export const SUPPLIER_INVOICE_ITEM_URL = `${BASE_API_URL}supplier-invoice-item`
export const SUPPLIER_UPDATE_TERMS_URL = `${BASE_API_URL}organisation/supplier-terms/bulk-update`

// Dual Warehouse URLs
export const DUAL_WAREHOUSE_STOCK_URL = `${BASE_API_URL}dual-warehouse-stock`
export const DUAL_WAREHOUSE_SUMMARY_URL = `${BASE_API_URL}dual-warehouse-summary`
export const ORDER_LOADING_URL = `${BASE_API_URL}order-loading`
export const DUAL_WAREHOUSE_TRANSFER_URL = `${BASE_API_URL}dual-warehouse-transfer`
